module.exports = __webpack_public_path__ + "Roboto-MediumItalic.fa183350bf6b814ae552.ttf";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-MediumItalic.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-MediumItalic.ttf
// module chunks = styles